// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"91842444","70":"858d355d","130":"984e9275","308":"3812fb73","401":"6d6f748c","787":"e0e4d77f"}[chunkId] + ".chunk.js";
};